import {uniqueId} from 'lodash';
import React, {useCallback, useEffect, useMemo, useState} from 'react';

import {useI18n} from '../../../../../../../data/hooks/i18nHooks';
import {useNetworkareaFilterCategory} from '../../../../../../../data/hooks/participant/useNetworkareaFilterCategory';
import {useTimedDeactivation} from '../../../useTimedDeactivation';
import styles from '../../BubblesFilter.module.scss';
import FilterButton from '../../FilterButton';
import FilterMenu from '../../FilterMenu/FilterMenu';

const CategoriesFilter = props => {
    const {event, filterParams, onExpandFilterMenu, activeFilter, onFilterActivation, onProtectRegion} = props,
        category = useNetworkareaFilterCategory(event.id),
        i18n = useI18n(),
        filterIsActive = !!filterParams?.categories?.[category?.name]?.length,
        [isActive, setActive, onMouseActivity] = useTimedDeactivation({timeout: 10000, ignoreTimeout: 500}),
        filterOptions = useMemo(
            () =>
                category?.options.map(option => ({
                    label: option.name,
                    value: option.value,
                    className: filterParams?.categories?.[category?.name]?.includes(option.name) ? styles.active : '',
                })) || [],
            [filterParams, category?.options]
        ),
        [filterId] = useState(uniqueId('filter-categories-')),
        [menuRect, setMenuRect] = useState(),
        moreHref = `${['/events', event.id, 'participants', 'filter'].join('/')}?cat=${encodeURIComponent(category?.name)}`;

    useEffect(() => {
        if (activeFilter != filterId) setActive(false);
    }, [activeFilter]);

    useEffect(() => {
        if (isActive) onFilterActivation(filterId);
    }, [isActive]);

    // remove bubbles from behind menu area
    useEffect(() => {
        onProtectRegion(filterId, menuRect);
    }, [menuRect]);
    useEffect(() => () => onProtectRegion(filterId, null), []);

    const handleFilterSelection = useCallback(
        option => {
            let isOn = filterParams?.categories?.[category.name]?.includes(option.label);
            if (isOn) {
                app.store.dispatch(app.actions.participants.removeCategoryFilter(event.id, category.name, option.label));
            } else {
                app.store.dispatch(app.actions.participants.addCategoryFilter(event.id, category.name, option.label));
            }
        },
        [event, category, filterParams]
    );

    const handleMouseActivity = useCallback(() => {
        onMouseActivity();
        onExpandFilterMenu();
    }, [onMouseActivity, onExpandFilterMenu]);

    // // TODO: remove this
    // useEffect(() => {
    //     setActive(true);
    // });
    // console.log(category, filterParams, filterParams?.categories?.[category.name]?.length);

    if (!category || !filterOptions.length) return null;

    return (
        <div className={[styles.filterControl].join(' ')} onClick={onMouseActivity} onMouseOver={handleMouseActivity} onMouseEnter={handleMouseActivity}>
            <FilterButton
                event={event}
                active={filterIsActive}
                icon="/img/filter_icon.png"
                onClick={onMouseActivity}
                onMouseOver={handleMouseActivity}
                onMouseEnter={handleMouseActivity}>
                {category.name}
            </FilterButton>
            <FilterMenu visible={isActive} options={filterOptions} moreHref={moreHref} onClick={handleFilterSelection} onRectUpdate={setMenuRect} />
        </div>
    );
};

export default CategoriesFilter;
